<template>
  <div class="modern-filter-rule d-flex flex-wrap flex-md-nowrap gap-2 align-items-center pt-1 pb-1">
    <div class="filter-logic text-right flex-shrink-0">
      <span v-if="indexInList === -1">条件:</span>
      <b-form-select
        v-else-if="indexInList === 0"
        class="flex-1 text-uppercase"
        :modelValue="operator"
        @update:modelValue="updateOperator"
        :options="options"
        size="sm"
      ></b-form-select>
      <span
        class="text-uppercase text-right"
        v-else
        >{{ filterObject.FilterGroupService.filterLogic }}</span
      >
    </div>
    <FilterRuleColumnAppend class="flex-shrink-0" />
    <component
      :is="calcedComponent"
      :modelValue="!!filterObject.value ? filterObject.value.value : null"
      @update:modelValue="updateValue"
      @update:operator="updateRuleOperator"
    />
    <FilterItemManagerForCustom class="ml-auto" />
  </div>
</template>
<script lang="ts">
import { computed } from 'vue'
import { FilterItemService } from '../../../FilterItemService'
import FilterItemManagerForCustom from '../FilterItemManagerForCustom.vue'
import FilterRuleColumnAppend from './FilterRuleColumnAppend.vue'

export default {
  components: {
    FilterRuleColumnAppend,
    FilterItemManagerForCustom,
  },
  provide() {
    return {
      filterObject: computed(() => this.filterObject),
    }
  },
  props: {
    filterObject: {
      type: FilterItemService,
      required: true,
    },
    indexInList: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      operator: 'and',
      options: ['and', 'or'],
    }
  },
  computed: {
    calcedComponent() {
      return this.filterObject.component
    },
  },
  methods: {
    updateOperator(val) {
      this.operator = val
      this.filterObject.updateOperator(val)
    },
    updateValue(value) {
      this.filterObject.updateValue(value)
    },
    updateRuleOperator(operator) {
      this.filterObject.updateItemOperator(operator)
    },
  },
}
</script>
